import React, { useState } from "react";

import Box                 from '@mui/material/Box';
import IconButton          from '@mui/material/IconButton';
import Typography          from '@mui/material/Typography';
import Menu                from '@mui/material/Menu';
import Avatar              from '@mui/material/Avatar';
import Button              from '@mui/material/Button';
import Tooltip             from '@mui/material/Tooltip';
import MenuItem            from '@mui/material/MenuItem';

const settings             = ['Profile', 'Dashboard', 'Logout'];

const initialState = {
	user: false,
};

export default function LoginUser () {
	const [{user}, setState] = useState (initialState);

	const handleUserToggle = (e) => {
		e.preventDefault();
		setState (prevState => ({ ...prevState, 'user': !user }));
	};

	if (!user)
		return (
			<Button
				variant="outlined"
				style={{color:'indigo', borderColor: "indigo", fontWeight: "bold"}}
			>
				Login
			</Button>
		);

	return (
		<Box sx={{ flexGrow: 0 }}>
			<Tooltip title="Open settings">
				<IconButton onClick={handleUserToggle} sx={{ p: 0 }}>
					<Avatar alt="#setUser" src="/static/images/avatar/2.jpg" />
				</IconButton>
			</Tooltip>
			<Menu
				sx={{ mt: '45px' }}
				id="menu-appbar"
				anchorEl={'user'}
				anchorOrigin={{
					vertical: 'top',
					horizontal: 'right',
				}}
				keepMounted
				transformOrigin={{
					vertical: 'top',
					horizontal: 'right',
				}}
				open={user}
				onClose={handleUserToggle}
			>
				{settings.map((setting) => (
					<MenuItem key={setting} onClick={handleUserToggle}>
						<Typography textAlign="center">{setting}</Typography>
					</MenuItem>
				))}
			</Menu>
		</Box>
	);
}
